var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.999 10.1416L14.999 16.3916L4.99902 10.1416V22.6416H24.999V10.1416ZM24.999 7.64157H4.99902L14.999 13.8791L24.999 7.64157Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 25.1416H24.999C26.374 25.1416 27.499 24.0166 27.499 22.6416V7.64157C27.499 6.26657 26.374 5.14157 24.999 5.14157H4.99902C3.62402 5.14157 2.49902 6.26657 2.49902 7.64157V22.6416C2.49902 24.0166 3.62402 25.1416 4.99902 25.1416ZM24.999 7.64157L14.999 13.8791L4.99902 7.64157H24.999ZM4.99902 10.1416L14.999 16.3916L24.999 10.1416V22.6416H4.99902V10.1416Z",
    fill: "#CBCBCB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6550f869dcf2fe2b31c47be0cb81c9a8.svg";
export { ForwardRef as ReactComponent };